import { PagedResultDto } from "@services/dto/pagedResultDto"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import http from "@services/httpService"
import { downloadFile } from "@lib/helperFile"
import dayjs from "dayjs"

class CostCenterService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/CostCenter/GetAll", {
      params,
    })
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/CostCenter/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/CostCenter/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/CostCenter/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(): Promise<any> {
    const res = await http.get("api/services/app/CostCenter/GetList")
    const { result } = res.data
    return result
  }
  public async getListForAdmin(): Promise<any> {
    const res = await http.get("api/services/app/CostCenter/GetListForAdmin")
    const { result } = res.data
    return result
  }
  public async export(params: any): Promise<any> {
    const res = await http.get(
      "api/Export/ExportCostCenter",

      {
        params,
        responseType: "blob",
      }
    )
    downloadFile(res.data, `EXPORT-COST-CENTER-${dayjs().format("DDMMYYYYHHmmss")}.xlsx`)
  }
  public async impport(file: File): Promise<any> {
    const formData = new FormData()
    formData.append("file", file)

    const result = await http.post("api/Imports/ImportCostCenter", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    })

    return result.data.result
  }
}

export default new CostCenterService()
